import { ApolloError } from '@apollo/client/errors/index.js';
import { EnumGraphQLErrorCode } from '@pendwa/common/@types/interfaces.js';
import { toast } from 'sonner';
import { logger } from '../logger/index.js';
const handleGraphQLErrors = (graphQLErrors, params = {
    handleNotification: true,
}) => {
    graphQLErrors.forEach((error) => {
        if ([EnumGraphQLErrorCode.USER_ERROR, EnumGraphQLErrorCode.ACCESS_DENIED_ERROR].includes(error.extensions.code)) {
            if (params.handleNotification) {
                toast.error(error.message, {
                    duration: 10000,
                });
            }
        }
        else {
            if (params.handleNotification) {
                toast.error(error.message, {
                    duration: 10000,
                });
            }
        }
    });
};
const handleGraphQLClientErrors = (errors, params = {
    handleNotification: true,
}) => {
    errors.forEach((error) => {
        if (params.handleNotification) {
            toast.error(error.message, {
                duration: 10000,
            });
        }
    });
};
export const defaultErrorsHandler = (error, params = {
    handleNotification: true,
}) => {
    if (!error) {
        return;
    }
    // check if error is GraphQLErrors
    if (Array.isArray(error) && error.length > 0 && typeof error[0] === 'object' && error[0].extensions) {
        handleGraphQLErrors(error, params);
    }
    else if (error instanceof ApolloError) {
        if (error.graphQLErrors.length > 0) {
            handleGraphQLErrors(error.graphQLErrors, params);
        }
        else if (error.networkError) {
            toast.error('Network error', {
                duration: 10000,
            });
        }
        else if (error.clientErrors) {
            logger.error(error);
            handleGraphQLClientErrors(error.clientErrors, params);
        }
        else if (error.message) {
            logger.error(error);
            toast.error(error.message, {
                duration: 10000,
            });
        }
        else {
            logger.error(error);
            toast.error('An unknown error occurred', {
                duration: 10000,
            });
        }
    }
    else {
        logger.error(error);
        toast.error('An unknown error occurred', {
            duration: 10000,
        });
    }
};
export const executeWithDefaultErrorsHandler = async (fn) => {
    try {
        return fn();
    }
    catch (error) {
        defaultErrorsHandler(error);
        return null;
    }
};
export const extractGraphQLErrorMessage = (error) => {
    if (!error) {
        return null;
    }
    // check if error is GraphQLErrors
    if (Array.isArray(error) && error.length > 0 && typeof error[0] === 'object' && error[0].extensions) {
        return error[0]?.message;
    }
    else if (error instanceof ApolloError) {
        if (error.graphQLErrors.length > 0) {
            return error.graphQLErrors[0]?.message;
        }
        else if (error.networkError) {
            return 'Network error.';
        }
        else if (error.clientErrors) {
            logger.error(error);
            return error.clientErrors[0]?.message ?? 'Something went wrong [client errors]';
        }
        else if (error.message) {
            logger.error(error);
            return error.message;
        }
        else {
            logger.error(error);
            return 'An unknown error occurred';
        }
    }
    else {
        return 'An unknown error occurred';
    }
};
//# sourceMappingURL=utils.js.map